import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PlateInfo from '../../models/plate-info.entity';
import storageService from '../../services/storage.service';
import { ActionRow, CancelBtn, SubmitBtn } from '../Inspection/Inspections.styles';
import PaymentHeader from '../Payment/components/PaymentHeader';
import { SubTitle } from '../Payment/components/PaymentHeader/PaymentHeader.styles';
import { Container, Form } from '../Payment/Payment.styles';
import { Spinner, Chassis, Description, Plate } from './PlateConfirmation.styles';
import plateService from '../../services/plate.service';
import { InspectionTypeEnum } from '../../models/enums/inspection-type.enum';

const PlateConfirmation = () => {
  const history = useHistory();
  const storagedPlateInfo = storageService.getObject('plateInfo');
  const vehicleType = storageService.getItem('inspection-type');
  const [plateInfo, setPlateInfo] = useState<PlateInfo>(new PlateInfo()); 
  const [loading, setLoading] = useState(false);
  const [requestError, setRequestError] = useState<boolean>(false);
  const data = useState<any>(null);
  const isAgriculturalMachine = vehicleType === InspectionTypeEnum.AGRICULTURAL_MACHINE;
  const isPlate = plateInfo && plateInfo.plate && plateInfo.plate.length === 7;

  if (!plateInfo.branchModel && storagedPlateInfo?.branchModel) {
    setPlateInfo(storagedPlateInfo);
  }

  const fetchData = async () => {
    setLoading(true);
    try {
      /* istanbul ignore if */
      if (vehicleType === 'VEHICLE') return;

      const result = await plateService.searchByPlate(storagedPlateInfo.chassis);
      setLoading(false);
      const fetchedData = result.data?.data;
      const { branch_model } = fetchedData;
      localStorage.setItem('branchModel', branch_model);
      const newPlateInfo = JSON.parse(JSON.stringify(plateInfo));
      newPlateInfo.branchModel = branch_model;
      newPlateInfo.chassis = storagedPlateInfo.chassis;
      setPlateInfo(newPlateInfo);
    } catch (error) {
      setLoading(false);
      setRequestError(true);

      setPlateInfo(storagedPlateInfo);

      console.error("Erro ao buscar dados da placa:", error);
    }
  };

  useEffect(() => {
    if (
      (storagedPlateInfo?.chassis || storagedPlateInfo?.plate)
      && !plateInfo.branchModel
      && !loading
      && !requestError
    ) {
      fetchData();
    }
  }, [storagedPlateInfo, data]); // eslint-disable-line react-hooks/exhaustive-deps

  const goToInspection = () => {
    history.push('inspection');
  };

  const goToVehicleIdentifier = () => {
    history.push('vehicle-identifier');
  };

  return (
    <Container>
      <PaymentHeader vehicleConfirm />
      <Form>
        <SubTitle>
          {isAgriculturalMachine
            ? 'A identificação do seu veículo está correta?'
            : `Confirme ${isPlate ? 'sua placa' : 'seu chassi'}`}
        </SubTitle>
        {isPlate && (<Plate>{/* istanbul ignore next */(plateInfo && plateInfo.plate) ? plateInfo.plate : '#######'}</Plate>)}
        {!isPlate && (<Chassis>{(storagedPlateInfo?.plate || storagedPlateInfo?.chassis) ? (storagedPlateInfo.plate || storagedPlateInfo.chassis) : '#######'}</Chassis>)}
        {isPlate && (<Description>{/* istanbul ignore next */plateInfo === null ? <Spinner /> : `${plateInfo.branchModel}`}</Description>)}
        {!isPlate && (<Description>{loading ? <Spinner /> : `${plateInfo.branchModel}`}</Description>)}
        <ActionRow>
          <SubmitBtn onClick={() => { goToInspection() }}>
            {isAgriculturalMachine ? 'Sim, continuar a compra' : 'Correto, continuar compra'}
          </SubmitBtn>
          <CancelBtn onClick={() => { goToVehicleIdentifier() }}>
            {isAgriculturalMachine ? 'Voltar' : 'A placa está incorreta'}
          </CancelBtn>
        </ActionRow>
      </Form>
    </Container>
  );
};

export default PlateConfirmation;
